// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'
import {Unlock_Stroke2_Corner2_Rounded as CanonicalUnlock_Stroke2_Corner2_Rounded} from './Unlock'

export const Lock_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M19.5 7.5h-3V5.25a4.5 4.5 0 0 0-9 0V7.5h-3A1.5 1.5 0 0 0 3 9v10.5A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5V9a1.5 1.5 0 0 0-1.5-1.5ZM9 5.25a3 3 0 0 1 6 0V7.5H9ZM19.5 19.5h-15V9h15v10.5Zm-6.375-5.25A1.125 1.125 0 1 1 12 13.125a1.125 1.125 0 0 1 1.125 1.125Z',
  viewBox: '0 0 24 24',
  glyph: 'Lock_Stroke2_Corner0_Rounded',
})

export const Lock_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M19.5 7.5h-3V5.25a4.5 4.5 0 0 0-9 0V7.5h-3A1.5 1.5 0 0 0 3 9v10.5A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5V9a1.5 1.5 0 0 0-1.5-1.5ZM9 5.25a3 3 0 0 1 6 0V7.5H9ZM19.5 19.5h-15V9h15v10.5Zm-6.375-5.25A1.125 1.125 0 1 1 12 13.125a1.125 1.125 0 0 1 1.125 1.125Z',
  viewBox: '0 0 24 24',
  glyph: 'Lock_Stroke2_Corner2_Rounded',
})

/** @deprecated Import Unlock_Stroke2_Corner2_Rounded from `#/components/icons/Unlock` instead. */
export const Unlock_Stroke2_Corner2_Rounded =
  CanonicalUnlock_Stroke2_Corner2_Rounded
